import React from 'react';
import templates from './templates';
import './ImageWidget.css';

export const IMAGE_WIDTH = 500;
export const IMAGE_HEIGHT = 350;

export const ImageWidget = ({ imageUrl = '', onSave, template = 'Fixed' }) => {
  const Template = templates[template];

  if (!Template) {
    console.error('Template not found:', template);
    return <div>Template not found: {template}</div>;
  }

  return (
    <Template
      imageUrl={imageUrl}
      onSave={onSave}
      FIXED_IMAGE_WIDTH={IMAGE_WIDTH}
      FIXED_IMAGE_HEIGHT={IMAGE_HEIGHT}
    />
  );
};
